import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductFromWebOrderDetails',
  props: {
    product: null
  },
  setup(__props: any) {



const showDetails = ref<boolean>(false);

return { __sfc: true,showDetails }
}

})